import CurrencyCell from 'components/CustomGridCell/CurrencyCell';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';

const props: AdjustmentCategoryGridProps = {
    category: AdjustmentType.CustomerDeduction,
    adjustmentTypes: [AdjustmentType.CustomerDeduction],
    title: 'Customer Deductions',
    dataItemKey: 'rowNumber',
    selectMode: 'multiple',
    selectionGroupField: 'customerId',
    selectionGroupTitle: 'Customer Number',
    gridColumns: [
        {
            field: 'customerId',
            title: 'Customer Number',
            filterTitle: 'text'
        },
        {
            field: 'customerName',
            title: 'Customer Name',
            filterTitle: 'text'
        },
        {
            field: 'invoiceId',
            title: 'Deduction Number',
            filterTitle: 'text'
        },
        {
            field: 'customerItemReference',
            title: 'Reference Number',
            filterTitle: 'text'
        },
        {
            field: 'adjustmentAmount',
            title: 'Amount',
            cell: CurrencyCell,
            filterTitle: 'numeric'
       }
    ]
}
export default props;
